const useClipboard = () => {
  const setToClipboard = async (value: string) => {
    return await navigator.clipboard.writeText(value);
  };

  return { setToClipboard };
};
export default useClipboard;
